import type {z} from 'zod'
import {isFeatureEnabled} from '@github-ui/feature-flags'

export const isValidationEnabled = () => {
  // isFeatureEnabled only works on the client
  if (typeof window === 'undefined') {
    return false
  }
  return isFeatureEnabled('contentful_response_validation')
}

/**
 * This allows us to skip the rendering of corrupt non-critical data.
 *
 * @param schema - Data that is safe to skip, should the data be invalid. The Zod .optional method will be appended.
 */
export const safeOptional = <T extends z.ZodTypeAny>(schema: T) => {
  if (!isValidationEnabled) {
    return schema.optional()
  }

  /* eslint-disable-next-line github/no-then --
    ESLint is incorrectly identifying .catch as part of a promise instead of the Zod method. */
  return schema.optional().catch((ctx: {error: z.ZodError}) => {
    // Bypasses the ErrorBoundary (which redirects to /500) while still logging to failbot.
    setTimeout(() => {
      throw ctx.error
    })

    return undefined
  })
}
